import context from "./purchaseOrderChangeLogContext";
import React, {useContext, useReducer} from "react";
import reducer from "./purchaseOrderChangeLogReducer";
import types from "./purchaseOrderChangeLogTypes";
import {AuthContext} from "../AuthContext";
import {NotificationContext} from "../NotificationContext";

const initialState = {
	loading: false,
	purchaseOrderChangeLogs: [],
};

export default ({children}) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const {token, setToken} = useContext(AuthContext);
	const {addToast} = useContext(NotificationContext);


    async function createPurchaseOrderChangeLog(purchaseOrderChangeLog) {
        dispatch({
            type: types.SET_LOADING,
        });

        const response = await fetch(process.env.REACT_APP_endPoint + '/graphql', {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                query: `
                    mutation createPurchaseOrderChangeLog($purchaseOrderChangeLog: CreatePurchaseOrderChangeLogInput!) {
                        createPurchaseOrderChangeLog(purchaseOrderChangeLog: $purchaseOrderChangeLog) {
                            id
                        }
                    }
                `,
                variables: {
                    purchaseOrderChangeLog: {
                        ...purchaseOrderChangeLog
                    }
                }
            })
        });
        if (response.status === 401) {
            setToken(null);
        }
        else {
            const json = await response.json();
            if (json.errors) {
                for (let i = 0; i < json.errors.length; i++) {
                    const {data} = json.errors[i];
                    if (data && data.length > 0) {
                        for (let j = 0; j < data.length; j++) {
                            addToast({
                                message: json.errors[i].message,
                                description: data[j]
                            });
                        }
                    }
                }
                dispatch({
                    type: types.SET_LOADING
                });
            }
            else {
                dispatch({
                    type: types.CREATE_PURCHASE_ORDER_CHANGE_LOG,
                    payload: json.data.createPurchaseOrderChangeLog
                });
            }
        }
    }
    return (
        <context.Provider value={{
            ...state,
            createPurchaseOrderChangeLog,
            dispatch
        }}>
            {children}
        </context.Provider>
    );
};